import React, { Component } from 'react'
import { graphql } from 'gatsby'
import he from 'he'

import SEO from '../components/seo'
import Header from '../components/header'
import Footer from '../components/footer'

import RenderBlock from '../utils/render-block'

class PageTemplate extends Component {

  render() {
    let page = this.props.data.wpPage

    return (
      <>
        <SEO title={he.decode(page.seo.title)} bodyClass={page.slug} description={page.seo.metaDesc} />
        { page.slug === 'home' && <Header isLight page={"isHome"} /> }
        { page.slug === 'location' && <Header page={"isLocation"} /> }
        { page.slug === 'gallery' && <Header page={"isGallery"} /> }
        { page.slug === 'contact' && <Header page={"isContact"} /> }
        { page.slug === 'activities' && <Header page={"isHome"} /> }
        { page.acf.contentBlocks && page.acf.contentBlocks.map((el, i) => RenderBlock(el.fieldGroupName, el, i))  }
        <Footer height={100} />
      </>
    )
  }
}

export const pageQuery = graphql`
  query ($id: String!) {
    wpPage(id: {eq: $id}) {
      title
      slug
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphImage {
          sourceUrl
          altText
          localFile {
            childImageSharp {
              original {
                src
                width
                height
              }
            }
          }
        }
      }
      acf {
        contentBlocks {
          __typename
          ... on WpPage_Acf_ContentBlocks_Hero {
            fieldGroupName
            backgroundImage {
              altText
              localFile {
                publicURL
              }
            }
            slider {
              localFile {
                publicURL
              }
            }
            title
            button {
              text
              link
            }
          }
          ... on WpPage_Acf_ContentBlocks_Gallery {
            fieldGroupName
            gallery {
              localFile {
                publicURL
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_RatingCard {
            fieldGroupName
            rating
            name
          }
          ... on WpPage_Acf_ContentBlocks_RoomsSlider {
            fieldGroupName
            rooms {
              ... on WpRoom {
                title
                slug
                acf {
                  card {
                    image {
                      altText
                      localFile {
                        childImageSharp {
                          fluid(maxWidth: 600, quality: 100) {
                            ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }
                    }
                    bedrooms
                    title
                    sleeps
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_RoomGrid {
            fieldGroupName
            roomsTop {
              ... on WpRoom {
                title
                slug
                acf {
                  card {
                    image {
                      altText
                      localFile {
                        childImageSharp {
                          fluid(maxWidth: 600, quality: 100) {
                            ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }
                    }
                    bedrooms
                    title
                    sleeps
                  }
                }
              }
            }
            backgroundImage {
              altText
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1600, quality: 100) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            title
            roomsBottom {
              ... on WpRoom {
                title
                slug
                acf {
                  card {
                    image {
                      altText
                      localFile {
                        childImageSharp {
                          fluid(maxWidth: 600, quality: 100) {
                            ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }
                    }
                    bedrooms
                    title
                    sleeps
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_LocationMap {
            fieldGroupName
            googleMap {
              latitude
              longitude
            }
            title
          }
          ... on WpPage_Acf_ContentBlocks_Locations {
            fieldGroupName
            locations {
              title
              subtitle
              content
              button {
                text
                link
              }
              contact {
                text
                link
              }
              image {
                altText
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_Accordion {
            fieldGroupName
            title
            items {
              image {
                altText
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              title
              content
              button {
                text
                link
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_ContactForm {
            fieldGroupName
            content
          }
          ... on WpPage_Acf_ContentBlocks_BannerImage {
            fieldGroupName
            backgroundImage {
              altText
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1600, quality: 100) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            title
          }
        }
      }
    }
  }
`

export default PageTemplate
